import bodyStyles from "./body"

const globalCss = {
    html: {
        focusVisibleRing: "none",
        focusRingWidth: 0,
    },
    body: {
        fontFamily: "canada-type-gibson, Arial",
        bg: "#fff",
        color: "white",
        minHeight: "100vh!important",
        "&.menu-isOpen": {
            height: "100vh",
        },
        "& p": {
            marginTop: "15px",
        },
    },
    "b, strong": {
        fontWeight: 600,
    },
    i: {
        fontStyle: "italic",
    },
    svg: {
        display: "inline-block",
    },
    h1: {
        fontSize: "34px",
        lineHeight: "34px",
        fontWeight: 600,
        color: "color1",
    },
    h2: {
        fontSize: "26px",
        lineHeight: "26px",
        fontWeight: 600,
        color: "color4",
        mt: "20px",
    },
    h3: {
        fontSize: "22px",
        lineHeight: "22px",
        fontWeight: 600,
        color: "color1",
        mt: "20px",
    },
    h4: {
        fontSize: "18px",
        lineHeight: "18px",
        fontWeight: 600,
        color: "color4",
        mt: "20px",
    },
    a: {
        _hover: {
            textDecoration: "none",
        },
    },
    "ol, ul": {
        listStyle: "disc",
    },
    //inner pages body styles
    ".body": bodyStyles,

    //custom homepage styles
    ".home main": {
        "& p": {
            fontSize: "lg",
        },
        "& ul": {
            fontSize: "lg",
        },
    },
    "main .slick-track": {
        margin: 0,
        p: {
            fontSize: "13px",
        },
    },
    // equalize heights of the upcoming events slider
    ".upcoming-slider": {
        "& .slick-track": {
            display: "flex !important",
            margin: 0,
        },
        "& .slick-slide": {
            height: "inherit !important",
            "> div": {
                height: "100%",
            },
        },
    },
    ".slick-dots": {
        bottom: "-55px",
        "& li button:before": {
            fontSize: "12px",
        },
    },
    ".tctmdNews-slider": {
        "& .slick-prev": {
            left: "-40px",
        },
        "& .slick-next": {
            right: "-40px",
        },
    },
    ".directors-slider": {
        "& .slick-track": {
            marginLeft: 0,
        },
    },
    ".channels-top-slider": {
        "& .slick-dots": {
            bottom: "20px",
            "& li button:before": {
                fontSize: "17px",
                color: "#fff",
                opacity: 0.5,
            },
            "& li.slick-active button:before": {
                opacity: 1,
            },
        },
        "& .slick-arrow": {
            width: "50px",
            height: "50px",
        },
        "& .slick-prev": {
            left: "-5px",
        },
        "& .slick-next": {
            right: "-5px",
        },
    },
    ".video-slider": {
        "& .slick-arrow": {
            top: { base: "45%", lg: "87px" },
        },
    },
    ".video-js": {
        width: "100%",
        paddingTop: "56.25%",
        video: {
            position: "absolute",
            top: 0,
            left: 0,
        },
    },
    ".chakra-checkbox__control": {
        mt: "3px",
    },
    ".crf-timezoneSelect": {
        option: {
            color: "#000",
        },
    },
    header: {
        "& h3": {
            color: "#fff",
        },
    },
    ".color1": { color: "color1" },
    ".color1-bg": { bgColor: "color1" },
    ".color2": { color: "color2" },
    ".color2-bg": { bgColor: "color2" },
    ".color3": { color: "color3" },
    ".color3-bg": { bgColor: "color3" },
    ".color4": { color: "color4" },
    ".color4-bg": { bgColor: "color4" },
    ".color5": { color: "color5" },
    ".color5-bg": { bgColor: "color5" },
    ".color6": { color: "color6" },
    ".color6-bg": { bgColor: "color6" },
    ".color7": { color: "color7" },
    ".color7-bg": { bgColor: "color7" },
    ".color8": { color: "color8" },
    ".color8-bg": { bgColor: "color8" },
    ".color9": { color: "color9" },
    ".color9-bg": { bgColor: "color9" },
    ".color10": { color: "color10" },
    ".color10-bg": { bgColor: "color10" },
    ".color11": { color: "color11" },
    ".color11-bg": { bgColor: "color11" },
    ".color12": { color: "color12" },
    ".color12-bg": { bgColor: "color12" },
    ".color13": { color: "color13" },
    ".color13-bg": { bgColor: "color13" },
    ".color14": { color: "color14" },
    ".color14-bg": { bgColor: "color14" },
    ".color15": { color: "color15" },
    ".color15-bg": { bgColor: "color15" },
    ".color16": { color: "color16" },
    ".color16-bg": { bgColor: "color16" },
}

export default globalCss
